<template>
  <div class="activityEdit">
    <div class="activityEditBox">
      <el-row>
        <el-col :span="22">{{ activityTitle }}</el-col>
        <el-col :span="2">
          <el-button
            type="info"
            round
            icon="el-icon-back"
            size="small"
            @click="goBack()"
          >
            返 回
          </el-button>
        </el-col>
      </el-row>
      <div class="formBox">
        <el-form
          :model="ruleForm"
          :rules="rules"
          ref="ruleForm"
          label-width="100px"
        >
          <el-form-item label="活动名称:" prop="name">
            <el-input
              v-model="ruleForm.name"
              placeholder="请输入活动名称"
              maxlength="100"
            ></el-input>
          </el-form-item>

          <el-form-item label="季度:" prop="quarterly">
            <el-select
              v-model="ruleForm.quarterly"
              clearable
              style="width: 100%"
            >
              <el-option
                v-for="(item, index) in quarterlyList"
                :key="index"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="活动上市时间:" prop="start">
            <el-date-picker
              v-model="ruleForm.startTime"
              value-format="yyyy-MM-dd"
              type="date"
              placeholder="选择日期"
              style="width: 100%"
              :locale="zhCn"
            >
            </el-date-picker>
          </el-form-item>

          <el-form-item label="上传截止时间:" prop="end">
            <el-date-picker
              v-model="ruleForm.endTime"
              value-format="yyyy-MM-dd"
              type="date"
              placeholder="选择日期"
              style="width: 100%"
              :locale="zhCn"
            >
            </el-date-picker>
          </el-form-item>
          <el-form-item label="任务类型:" prop="type">
            <el-radio-group v-model="ruleForm.type" class="radio">
              <el-radio label="temp" name="type">临时任务</el-radio>
              <el-radio label="day" name="type">日任务</el-radio>
              <el-radio label="week" name="type">周任务</el-radio>
              <el-radio label="month" name="type">月任务</el-radio>
            </el-radio-group>
          </el-form-item>

          <el-form-item label="截止提交:" prop="weekEnd" v-if="ruleForm.type === 'week'">
            <!--            <el-select v-model="ruleForm.weekStart" placeholder="起始星期" style="width:130px">-->
            <!--              <el-option label="周日" :value="0"/>-->
            <!--              <el-option label="周一" :value="1"/>-->
            <!--              <el-option label="周二" :value="2"/>-->
            <!--              <el-option label="周三" :value="3"/>-->
            <!--              <el-option label="周四" :value="4"/>-->
            <!--              <el-option label="周五" :value="5"/>-->
            <!--              <el-option label="周六" :value="6"/>-->
            <!--            </el-select>-->
            <!--            <span style="margin:0 10px">至</span>-->
            <el-select v-model="ruleForm.weekEnd" placeholder="结束星期" style="width:130px">
              <el-option label="周日" :value="0"/>
              <el-option label="周一" :value="1"/>
              <el-option label="周二" :value="2"/>
              <el-option label="周三" :value="3"/>
              <el-option label="周四" :value="4"/>
              <el-option label="周五" :value="5"/>
              <el-option label="周六" :value="6"/>
            </el-select>
          </el-form-item>

          <el-form-item label="导购可完成:" prop="enableSales">
            <el-checkbox v-model="ruleForm.enableSales">导购可完成</el-checkbox>
          </el-form-item>

          <el-form-item label="适用门店:" prop="end">
            <el-upload
              class="upload-demo"
              ref="upload"
              multiple
              :action="doorUploadUrl"
              :on-preview="handlePreviewDoor"
              :on-remove="handleRemoveDoor"
              :on-success="handleSuccess"
              :before-remove="handleBeforeRemoveDoor"
              :file-list="fileList"
              :headers="myHeaders"
              :auto-upload="true"
              :limit=1
              :data="{type: 4}">
              <el-button size="small" type="success">选择文件</el-button>
              <div slot="tip" class="el-upload__tip">只能上传excel文件，且不超过500MB</div>
            </el-upload>
          </el-form-item>

          <div class="attachments">
            <span class="label">附件:</span>
            <div class="attachmentsContent">
              <el-upload
                class="upload-demo"
                ref="upload"
                :action="attachmentsUploadUrl"
                :on-preview="handlePreview"
                :on-remove="handleRemoveAttachment"
                :before-remove="handleBeforeRemove"
                :on-success="handleSuccessAttachment"
                :file-list="attachmentList"
                :auto-upload="true"
                :limit=3
                accept=".pdf,.jpeg"
                :data="{type: 4}"
              >
                <el-button slot="trigger" size="small" type="primary">选取文件</el-button>
                <div slot="tip" class="el-upload__tip">只能上传pdf/jpg文件，且不超过500MB</div>
              </el-upload>
            </div>
          </div>

          <el-form-item label="状态:" prop="enabled">
            <el-switch
              v-model="ruleForm.enabled"
              active-color="#67C23A"
            >
            </el-switch>
          </el-form-item>
        </el-form>
      </div>
      <footer>
        <el-button type="success" @click="save()">
          保 存
        </el-button>
      </footer>
    </div>
    <el-dialog
      title="上传预览"
      :visible.sync="dialogVisible"
      width="60%"
    >
      <div>
        <el-table :data="fileData">
          <el-table-column property="number" label="序号" width="150"></el-table-column>
          <el-table-column property="posId" label="门店编号" width="200"></el-table-column>
          <el-table-column property="name" label="系统内门店名称"></el-table-column>
          <el-table-column property="status" label="匹配状态" width="150">
            <template slot-scope="scope">
              <template v-if="scope.row.status">
                <i style="color: #67C23A" class="el-icon-check"></i>
              </template>
              <template v-else>
                <i style="color: red" class="el-icon-close"></i>
              </template>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button type="success" @click="submitFileData()">确认上传</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import Cookies from "js-cookie";
import {downloadFile} from "@/utils/tool";
import _ from 'lodash'

export default {
  name: "ActivityEdit",
  data() {
    const domain = window.location.origin;
    return {
      myHeaders: {token: Cookies.get('token')},
      activityTitle: "",
      doorUploadUrl: vmsReqUrl + "/activity/uploadDoorPreview",
      attachmentsUploadUrl: pubServer + "/upload/upload",
      id: this.$route.query.id || null,
      rules: {}, // 验证信息
      ruleForm: {
        name: "",  //活动名称
        startTime: "",
        endTime: "",
        enabled: false,  //状态
        doorNos: "", //适用门店
        fileVoList: [],  //附件
        type: 'temp',
        weekStart: "",
        weekEnd: "",
        enableSales: false
      },
      quarterlyList: [{
        value: 1,
        label: '第一季度'
      },
        {
          value: 2,
          label: '第二季度'
        },
        {
          value: 3,
          label: '第三季度'
        },
        {
          value: 4,
          label: '第四季度'
        }],
      fileList: [],
      attachmentList: [], //附件
      dialogVisible: false,
      fileData: [],
      fileDataRow: {},  //门店上传预览数据行

      // imageUrl: [],  //附件
    }
  },
  mounted() {
    if (this.id == null) {
      this.activityTitle = "新增市场活动";
    } else {
      this.activityTitle = "编辑市场活动";
      this.getData()
    }
  },
  methods: {
    async getData() {
      let url = "activity/" + this.id;
      let res = await axios.post(vmsReqUrl + url);
      res = res.data;
      if (res.code === 200) {
        this.ruleForm = res.data.activity;
        this.attachmentList = _.map(res.data.activityFileList, (file) => {
          file.url = file.docUrl
          return file
        });
        this.fileList = [
          {
            url: '',
            name: '适用门店'
          }
        ]
        console.log('this.attachmentList', this.attachmentList)
      }
    },
    goBack() {
      this.$router.push({path: '/vms/activityManage'});
    },
    async save() {
      const loadingInstance = this.$loading({text: '提交中...'});
      try {
        this.ruleForm.fileVoList = this.attachmentList;
        if (this.id == null) {  //新增
          let res = await axios.post(vmsReqUrl + "activity/save", this.ruleForm);
          res = res.data;
          if (res.code === 200) {
            // this.$message.success(res.message);
            this.$router.push({path: '/vms/activityManage'});
          } else {
            // this.$message.warning(res.message);
          }
        } else { //修改
          let res = await axios.put("activity", this.ruleForm);
          res = res.data;
          if (res.code === 200) {
            // this.$message.success(res.message);
            this.$router.push({path: '/vms/activityManage'});
            // this.$message.success(res.message);
          } else {
            // this.$message.warning(res.message);
          }
        }
      } catch (err) {
        this.$message.error('请求失败');
      } finally {
        loadingInstance.close();
      }
    },
    async submitUpload(file, fileList) {
      // 手动上传文件的方法
      // let res = this.$refs.upload.submit();
      // let formData = new FormData();
      // formData.append("file", fileList[0]);
      // let res = await axios.post("activity/uploadDoorPreview", formData);
      // console.log('res:', res.data.code)
    },
    async handleSuccessAttachment(response, file, fileList) {
      if (response.code === 200) {
        let res = response.data;
        let urls = {name: res.result.filename, docUrl: res.result.imageUrl};
        this.attachmentList.push(urls)

      } else {
        this.$message.error(response.message)
      }

    },
    handleSuccess(response, file, fileList) {
      //this.$refs.upload.clearFiles();
      this.dialogVisible = true;

      let fileDataTemp = [];
      let doorStr = "";
      response.data.succList.forEach(function (item, index) {
        let row = {number: index + 1, posId: item.posId, name: item.name, status: true};
        fileDataTemp.push(row);
        if (index === 0)
          doorStr += item.doorNo;
        else
          doorStr += "," + item.doorNo;
      })
      this.fileData = fileDataTemp;
      fileDataTemp = [];
      let maxIndex = this.fileData.length;
      response.data.errorList.forEach(function (item, index) {
        let row = {'number': index + maxIndex + 1, posId: item, name: '', status: false};
        fileDataTemp.push(row);
      })
      this.fileData = this.fileData.concat(fileDataTemp);

      this.ruleForm.doorNos = doorStr;
    },
    handleRemoveAttachment(file, fileList) {
      let attachmentListTemp = []
      this.attachmentList.forEach((item) => {
        if (item.uid != file.uid) {
          attachmentListTemp.push(item)
        }
      })
      this.attachmentList = attachmentListTemp
    },
    handleRemoveDoor(file, fileList) {
      let doorListTemp = []
      this.fileList.forEach((item) => {
        if (item.uid != file.uid) {
          doorListTemp.push(item)
        }
      })
      this.fileList = doorListTemp
    },
    async handlePreviewDoor() {
      let {data, fileName} = await this.$tool.exportFile({
        method: "post",
        url: vmsReqUrl + "/activity/export/" + this.id,
      });
      console.log(data, fileName);
    },
    handleBeforeRemoveDoor(file, fileList) {
      console.log('file', file)
      console.log('fileList', fileList)
      this.$confirm("确认删除吗？", "提示", {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(async () => {
          this.handleRemoveDoor()
          return false
        })
        .catch(_ => {
          fileList.push(file)
          this.fileList = fileList
          // this.getData()
          return false
        })
    },
    handlePreview(file) {
      console.log(file);
      const fileUrl = file.url || file.docUrl
      downloadFile(fileUrl, file.name);
      window.open(fileUrl)
    },
    submitFileData() {
      // todo: 提交excel转换的数据列表
      this.dialogVisible = false
    },
    handleBeforeRemove(file, fileList) {
      console.log('file', file)
      console.log('fileList', fileList)
      this.$confirm("确认删除吗？", "提示", {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(async () => {
          this.handleRemoveAttachment()
          return false
        })
        .catch(_ => {
          fileList.push(file)
          this.attachmentList = fileList
          // this.getData()
          return false
        })
    },
  }
};
</script>
<style lang="sass" scoped>
.activityEdit
  min-width: 1050px

  .activityEditBox
    padding: 20px

    .formBox
      width: 50%
      margin-left: 25%
      margin-top: 20px

    .attachments
      display: flex
      margin-bottom: 20px

      .label
        text-align: right
        width: 100px
        vertical-align: middle
        float: left
        font-size: 14px
        color: #606266
        line-height: 36px
        padding: 0 12px 0 0
        -webkit-box-sizing: border-box
        box-sizing: border-box
        flex-shrink: 0

      .attachmentsContent
        line-height: 36px
        width: 100%

    footer
      padding-top: 20px
      text-align: center

  .dialog-footer
    text-align: center
</style>



// WEBPACK FOOTER //
// src/vms/pages/views/activity/activityEdit.vue